module.exports = __webpack_public_path__ + "img/t_0025.4ce78224.gif";